// activityUsTrade
export default {
  routerTitle: '寻找美股交易达人',

  shareTitle: '寻找美股交易达人！',
  shareDesc: '限时免佣、免平台费！还有1000HKD现金奖励等你来拿！',

  cardOneTitle: '限免激励',
  usTrade: '美股交易',
  cardOneText1: '免佣金、免平台费',
  cardOneText2: '不限交易金额、次数',

  cardTwoTitle: '最高累计奖励现金 HKD 1000',
  cardTwoRowRight: '累计奖励',
  cardTwoRowLeft1: '交易 ≥ 20笔',
  cardTwoRowRight1: 'HKD 100',

  cardTwoRowLeft2: '交易 ≥ 50笔',
  cardTwoRowRight2: 'HKD 200',

  cardTwoRowLeft3: '交易 ≥ 100笔',
  cardTwoRowRight3: 'HKD 400',

  cardTwoRowLeft4: '交易 ≥ 500笔',
  cardTwoRowRight4: 'HKD 1000',

  cardTwoTips:
    '备注：客户活动期间累计交易 20笔获得 100现金，再交易 30笔累计交易 50笔 ，再获得 100现金，共获得 200现金；以此类推，最高可获得 1000现金。'
}
